import _ from 'lodash'
import { ValidityDeterminate } from '@fusion-advantage/backcompat'
import { NeurologicWeaknessConcept, WeaknessEtiology, cidForDirValue, ExecutableCalc, CalcType, ExecutableCalcCalculateOk, CalcRuntimeError, ExecutableCalcCalculateFunction } from '@fusion-advantage/formlib'
import { createSelector } from '@reduxjs/toolkit'
import { FormRootState } from '../../redux/formStore'
import { ok, Result } from 'neverthrow'

//
//
// NEUROLOGIC WEAKNESS HUMANOID
//

export const createNeurologicWeaknessValidationCalc = (getState: () => FormRootState) => {
	const selectCalculateFn = createSelector(
		(state: FormRootState) => state.neurologicWeaknessReview.models,
		(models): ExecutableCalcCalculateFunction => {
			return (ctx): Result<ExecutableCalcCalculateOk, CalcRuntimeError> => {
				const leosSelected = ctx.substatusValue("ch52wCa6ZYYH2iyLDklcV2Ml", cidForDirValue("Paralysis / Paresis"))
				const noStrokeSelected = _.filter(models, item => item.etiology === WeaknessEtiology.Stroke).length === 0

				if(leosSelected && noStrokeSelected) {
					return ok({
						calcType: CalcType.Validation,
						returnValue: {
							determinate: ValidityDeterminate.Required,
							message: 'Neurologic weakness humanoid is required',
						}
					})
				}

				return ok({
					calcType: CalcType.Validation,
					returnValue: {
						determinate: ValidityDeterminate.Valid,
					}
				})
			}
		}
	)
	return new ExecutableCalc({
		calcType: CalcType.Validation,
		outputCid: NeurologicWeaknessConcept.cid,
		inputCids: [NeurologicWeaknessConcept.cid, "ch52wCa6ZYYH2iyLDklcV2Ml"],
		selectCalculate: () => selectCalculateFn(getState())
	})
}